<div class="w-100 d-flex flex-column outer-div" [class.error-container]="highlightFields()">
  <div class="d-flex flex-row">
    <span [class.disabled]="disabledStyle" *ngIf="label && showRequiredAsterisk && showLabel"
           [class.highlightable]="!highlightFields()"
           [class.error-label]="highlightFields()" class="input-field-label"> {{label}}*</span>

    <span [class.disabled]="disabledStyle" *ngIf="label && !showRequiredAsterisk && showLabel"
           [class.highlightable]="!highlightFields()"
           [class.error-label]="highlightFields()" class="input-field-label"> {{label}}</span>
    <span class="input-field-label" *ngIf="!label && showLabel">&#8203;</span>
    <app-info-icon *ngIf="showInfo === true"
                   [header]="header"
                   [mainContent]="mainContent"
                   [isCentered]="isCentered"
                   [marginValue]="marginValue"></app-info-icon>
  </div>
  <ng-content></ng-content>
  <ng-container *ngIf="control?.dirty||control?.touched">
    <div *ngIf="control?.errors?.['required']" class="error-label">
      <ng-container *ngIf="label">
        <img class="mr-1" src="assets/img/form/error.svg" alt="">
        {{'createProposal.required'|translate: {label: label} }}
      </ng-container>
      <ng-container *ngIf="!label">
        <img class="mr-1" src="assets/img/form/error.svg" alt="">
        {{'createProposal.required'|translate: {label: 'Dies'} }}
      </ng-container>
    </div>
    <div *ngIf="control?.errors?.['futureDate']" class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.dateMustBeInTheFuture'|translate: {label: label} }}
    </div>
    <div *ngIf="highlightField && labelForErrorMessage" class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.mustBeBefore'|translate: {firstDate: label, secondDate: labelForErrorMessage} }}
    </div>
    <div *ngIf="control?.errors?.['number']" class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.notANumber'|translate}}
    </div>
    <div *ngIf="control?.errors?.['positive']" class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.mustBePositive'|translate}}
    </div>
    <div *ngIf="control?.errors?.['email']" class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.invalidEmail'|translate}}
    </div>
    <div *ngIf="control?.errors?.['whitespace']" class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.invalidInput'|translate}}
    </div>
    <div *ngIf="control?.errors?.['integer']" class="error-label">
      <img class="mr-1" src="assets/img/form/error.svg" alt="">
      {{'createProposal.enterInteger'|translate}}
    </div>
  </ng-container>
</div>
